export var ColorOptions;
(function (ColorOptions) {
    ColorOptions["LightGrey"] = "lightgrey";
    ColorOptions["Red"] = "red";
    ColorOptions["Blue"] = "blue";
    ColorOptions["Green"] = "green";
    ColorOptions["Yellow"] = "yellow";
    ColorOptions["DarkBlue"] = "darkblue";
    ColorOptions["Purple"] = "purple";
    ColorOptions["InstructorIssues"] = "instructorIssues";
    ColorOptions["ResourceIssues"] = "resourceIssues";
})(ColorOptions || (ColorOptions = {}));
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["XS"] = "xs";
    Breakpoints["SM"] = "sm";
    Breakpoints["MD"] = "md";
    Breakpoints["LG"] = "lg";
})(Breakpoints || (Breakpoints = {}));
export var Mode;
(function (Mode) {
    Mode["Dark"] = "dark";
    Mode["Light"] = "light";
})(Mode || (Mode = {}));
